import { ReactElement, useEffect } from 'react'
import { DrawerProps } from './props'
import { StyledDrawer } from './styles'
import { Backdrop } from '../../Atoms'

const Drawer = ({
    ['data-cy']: dataCy,
    children,
    onClose = () => undefined,
    onOpen = () => undefined,
    open = false,
    position = 'bottom',
    ...props
}: DrawerProps): ReactElement => {
    useEffect(() => {
        if (open) onOpen()
    }, [onOpen, open])

    return (
        <Backdrop open={open} onClick={onClose} data-cy={dataCy ?? 'drawer'}>
            <StyledDrawer
                {...props}
                onClick={(e) => e.stopPropagation()}
                open={open}
                position={position}
            >
                {children}
            </StyledDrawer>
        </Backdrop>
    )
}

export default Drawer

export { StyledDrawer }
